import { Logo, LogoColor } from "./LogoAppStyles.styled";

export const LogoApp = () => {
  return (
    <>
      <Logo>
        Safe<LogoColor>Tasker</LogoColor>
      </Logo>
    </>
  );
};
